import { Note } from '../../../shared/ui/note';

export const ReplayNote = ({ name, className }: { name: string; className?: string }) => (
  <Note tone="danger" className={className}>
    <span className="text-data leading-20 text-primary">
      This scheme does not sign a timestamp.
    </span>
    <span className="mt-2 block">
      A captured request stays valid forever, so there is no protection against replay. That is how{' '}
      {name} signs, not a setting you left off.
    </span>
  </Note>
);
